import React from 'react';

function getSelectionModifier({ blockName, isSelected, isAnySelected, }){
  if (!isSelected && !isAnySelected) {
    return '';
  }
  if (isSelected) {
    return `${ blockName }__item--selected`;
  }
  if (isAnySelected) {
    return `${ blockName }__item--unselected`;
  }
}

function getImage({ reaction, }){
  return reaction.image;
}

export default function ReactionListItem({
  reaction, blockName, percentage, showVoteResults, isSelected,
    onReactionClicked, isAnySelected, }){
  const { id: reactionId, } = reaction;
  const percentageVisibilityModifier = showVoteResults ?
    `${ blockName }__item-percentage--visible` : '';
  const itemPercentageClassNames = `${ blockName }__item-percentage
    ${ percentageVisibilityModifier }`;
  const selectionModifier = getSelectionModifier({
    blockName, isSelected, isAnySelected, });
  const itemClassNames = `${ blockName }__item ${ selectionModifier }`;
  const { text, } = reaction;
  const image = getImage({ reaction, });
  return (
    <li className={ `${ blockName }__list-item` }>
      <button
        type='button'
        disabled={ isAnySelected }
        className={ itemClassNames }
        onClick={ (e) => onReactionClicked({ reactionId, }) }
      >
        <div
          className={ `${ blockName }__item-image` }
          style={ { backgroundImage: `url('${ image }')` } }
        />
        <div className={ `${ blockName }__item-text` }>
          { text }
        </div>
        <div className={ itemPercentageClassNames }>
          { percentage }%
        </div>
      </button>
    </li>
  );
}


// WEBPACK FOOTER //
// ./provolution/app/views/provolution/components/reactions/components/reactionListItem.js